/** @type {Styles} */
export const styles = {
  container: {
    my: 8,
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    bgcolor: 'background.default',
  },
  paper: {
    borderRadius: 2,
    overflow: 'hidden',
    position: 'relative',
    bgcolor: 'background.paper',
  },
  colorBand: {
    height: 8,
    width: '100%',
    bgcolor: 'primary.main',
  },
  contentContainer: {
    p: { xs: 3, md: 6 },
  },
  iconContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    mb: 4,
  },
  iconCircle: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    bgcolor: 'action.hover',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconText: {
    fontSize: 40,
    color: 'primary.main',
    fontWeight: 'bold',
  },
  title: {
    textAlign: 'center',
    fontWeight: 600,
    mb: 2,
    color: 'primary.main',
  },
  description: {
    textAlign: 'center',
    mb: 4,
    color: 'text.secondary',
    maxWidth: '600px',
    mx: 'auto',
  },
  buttonContainer: {
    direction: { xs: 'column', sm: 'row' },
    spacing: 2,
    justifyContent: 'center',
    mb: 4,
    display: 'flex',
    gap: 2,
  },
  supportSection: {
    textAlign: 'center',
    pt: 3,
    mt: 3,
    borderTop: 1,
    borderColor: 'divider',
  },
  supportText: {
    mb: 1,
    color: 'text.secondary',
  },
  supportLink: {
    color: 'primary.main',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '80vh',
    py: 4,
    textAlign: 'center',
    bgcolor: 'background.default',
  },
}
